var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickTeamFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 9.89917,
    cy: 9,
    r: 9,
    fill: "#36A6A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03391 11.4368C8.8654 11.4368 8.69689 11.3731 8.56824 11.2448L6.78305 9.46508C6.52577 9.20858 6.52577 8.79308 6.78305 8.53733C7.04034 8.28083 7.45635 8.28008 7.71364 8.53658L9.03391 9.85283L12.1394 6.75683C12.3967 6.50033 12.8127 6.50033 13.07 6.75683C13.3273 7.01333 13.3273 7.42883 13.07 7.68533L9.49958 11.2448C9.37094 11.3731 9.20243 11.4368 9.03391 11.4368Z",
    fill: "#36A6A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickTeamFilterIcon);
export default __webpack_public_path__ + "static/media/tickTeamFilterIcon.2f2bfd98b5bf4a400538b73cbac648f1.svg";
export { ForwardRef as ReactComponent };